$(function(){ 
  /*スムーススクロール*/
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
  
  /*店舗検索*/
  $(".extraction").change(function() {
    var extraction_val = $(".extraction").val();
    if(extraction_val == "選択") {
        $('.shop-wrap').css('display', 'none');
    }else if(extraction_val == "東京都") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'block');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
    
    }else if(extraction_val == "神奈川県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'block');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');

    }else if(extraction_val == "千葉県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'block');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "埼玉県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'block');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "茨城県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'block');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "栃木県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'block');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
    
    }else if(extraction_val == "群馬県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'block');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "山梨県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'block');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "愛知県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'block');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "岐阜県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'block');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "三重県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'block');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "福岡県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'block');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "佐賀県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'block');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "大分県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'block');
        $('.yamaguchi').css('display', 'none');
      
    }else if(extraction_val == "山口県") {
        $('.shop-wrap').css('display', 'block');
        $('.tokyo').css('display', 'none');
        $('.kanagawa').css('display', 'none');
        $('.chiba').css('display', 'none');
        $('.saitama').css('display', 'none');
        $('.ibaraki').css('display', 'none');
        $('.tochigi').css('display', 'none');
        $('.gunma').css('display', 'none');
        $('.yamanashi').css('display', 'none');
        $('.aichi').css('display', 'none');
        $('.gifu').css('display', 'none');
        $('.mie').css('display', 'none');
        $('.fukuoka').css('display', 'none');
        $('.saga').css('display', 'none');
        $('.ooita').css('display', 'none');
        $('.yamaguchi').css('display', 'block');
    }
});

/*アコーディオン*/
	$('.accordion-wrap > li p').click(function(){
		//クリックされた.accordion-wrapの中のp要素に隣接するul要素が開いたり閉じたりする。
		$(this).next('ul').slideToggle();
    /*矢印の向きを変更*/
    $(this).toggleClass('open');
	});

	$('.accordion-wrap .inner > li p').click(function() {
		//クリックされた.accordion-wrapの中の.innerの中のli要素の中のp要素の子要素のul要素が開いたり閉じたりする。
		$(this).children('ul').slideToggle();
    /*矢印の向きを変更*/
    $(this).toggleClass('open');
  });
  
  /*アコーディオン１*/
	$('.accordion-wrap1 dt').click(function(){
		$(this).next('dd').slideToggle(); 
     /*矢印の向きを変更*/
    $(this).toggleClass('open');
	});
  
  /*アコーディオン２*/
	$('.accordion-wrap2 dt').click(function(){
		$(this).next('dd').slideToggle();
     /*矢印の向きを変更*/
    $(this).toggleClass('open');
	});

  $('.tab li').click(function() {
    // 〜〜コンテンツについての処理〜〜
    //クリックされたタブの番号をindexに格納。
    var index = $('.tab li').index(this);
    //コンテンツを一旦全て非表示に。
    $('.contents li').css('display','none');
    // クリックされた番号のコンテンツを表示。
    $('.contents li').eq(index).css('display','block');
    // 〜〜タブについての処理〜〜
    // 一度タブについている'tab_current'を消し
    $('.tab li').removeClass('tab_current');
    //クリックされたタブのみに'tab_current'をつける。
    $(this).addClass('tab_current')
    });
  
});